import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  title: {
    id: 'jutro-components.widgets.PopoverContainer.title',
    defaultMessage: 'Popover Container'
  }
});